/**
 * Fidel's card-linking form (Web SDK v3): an iframe served from
 * resources.fidel.uk, so the card number goes straight to Fidel and never
 * through Defera. The script refuses to run from anywhere else, so it is
 * always injected from that URL (the server sends it with the config).
 */
export const FIDEL_SDK_ORIGIN = 'https://resources.fidel.uk';

let loading = null;

export function loadFidelSdk(src) {
  if (typeof window === 'undefined') return Promise.reject(new Error('no window'));
  if (window.Fidel?.openForm) return Promise.resolve(window.Fidel);
  if (!String(src || '').startsWith(`${FIDEL_SDK_ORIGIN}/`)) return Promise.reject(new Error('unexpected SDK source'));
  if (loading) return loading;
  loading = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = src;
    script.async = true;
    script.dataset.id = 'fidel-sdk';
    script.onload = () => (window.Fidel?.openForm ? resolve(window.Fidel) : reject(new Error('Fidel SDK did not start')));
    script.onerror = () => { loading = null; reject(new Error('Could not load the card form')); };
    document.head.appendChild(script);
  });
  return loading;
}

/** Open the form with the config from GET /api/rewards/cards/sdk-config. */
export async function openFidelCardForm(config, { onEnrolled, onFailed, onCancelled }) {
  const Fidel = await loadFidelSdk(config.sdkSrc);
  Fidel.openForm({
    companyName: config.companyName,
    sdkKey: config.sdkKey,
    programId: config.programId,
    countries: config.countries,
    metadata: config.metadata,
    custom: { terms: { ...config.terms } },
    onCardEnrolledCallback: (card) => onEnrolled?.(card),
    onCardEnrollFailedCallback: (error) => onFailed?.(error),
    onUserCancelledCallback: () => onCancelled?.(),
  });
}
